import { FC, forwardRef, useImperativeHandle, useRef } from 'react';
import { TEXT_TOOLTIP_INNER_STYLE } from './index';
import styles from './index.module.less';
import { Typography } from 'antd';
import V2VideoPlayer from '@/common/components/Data/V2VideoPlayer';

/**
 * 单个视频示例项（含 V2VideoPlayer + 时长展示）
 * @description 通过隐藏的原生 video 元素读取 metadata 获取视频时长，
 * V2VideoPlayer 内部已通过 videojs 加载视频，但其未暴露 loadedmetadata 回调，
 * 因此用一份额外的 preload='metadata' 元素读取时长（仅请求元数据，开销很小）。
 */
const VideoExampleItem: FC<{
  /** 视频地址 */
  src: string;
  /** 视频说明文案 */
  caption?: string;
  ref?: any,
}> = forwardRef(({ src, caption }, ref) => {

  useImperativeHandle(ref, () => ({
    pause: () => {
      playerRef.current?.video?.current?.pause();
    },
    play: () => {
      playerRef.current?.video?.current?.play();
    },
  }));

  /** V2VideoPlayer ref，暴露的 video 字段实际指向 videojs player 实例（具备 pause() 方法） */
  const playerRef = useRef<any>(null);

  return (
    <div className={styles.videoItem}>
      <div className={styles.videoPlayerWrapper}>
        <V2VideoPlayer
          ref={playerRef}
          src={src}
          width='100%'
          height={200}
          pictureInPictureToggle={false}
          showDuration={true}
        />
      </div>
      {/* 视频说明：超出宽度时鼠标悬浮显示完整内容 */}
      {caption && (
        <Typography.Text
          className={styles.videoCaption}
          ellipsis={{
            tooltip: {
              title: caption,
              overlayInnerStyle: TEXT_TOOLTIP_INNER_STYLE,
            },
          }}
        >
          {caption}
        </Typography.Text>
      )}
    </div>
  );
});

export default VideoExampleItem;
